module.exports = __webpack_public_path__ + "12d8c3aaa26002089c14e9c220d96903.png";